import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Camera, Clock, Users, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IMAGES } from "@/lib/constants";
import { api } from "@/lib/api";

export default function Tourist() {
  const [packages, setPackages] = useState([]);
  useEffect(() => { api.get("/tourist-packages").then(({ data }) => setPackages(data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="relative bg-navy">
        <img src={IMAGES.skyline} alt="UK" className="absolute inset-0 h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-navy/65" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24 text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white"><Camera size={14} className="text-brand" /> Tourist Travel</span>
          <h1 className="mt-4 font-heading text-4xl font-bold text-white lg:text-5xl">Explore the UK Your Way</h1>
          <p className="mx-auto mt-4 max-w-xl text-slate-300">Private taxi, professional driver, flexible stops, hotel pickup and a custom itinerary.</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="font-heading text-2xl font-bold text-navy">Recommended tourist packages</h2>
        <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {packages.map((p) => (
            <div key={p.key} className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
              <img src={IMAGES.countryside} alt={p.title} className="h-40 w-full object-cover" />
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-navy">{p.title} — {p.hours} Hours</h3>
                <p className="mt-2 text-sm text-slate-500">{p.desc}</p>
                <div className="mt-3 flex flex-wrap gap-3 text-xs text-slate-500">
                  <span className="flex items-center gap-1"><Clock size={13} className="text-brand" /> {p.hours}h</span>
                  <span className="flex items-center gap-1"><MapPin size={13} className="text-brand" /> {p.city}</span>
                  <span className="flex items-center gap-1"><Users size={13} className="text-brand" /> Private</span>
                </div>
                <div className="mt-4 flex items-center justify-between">
                  <span className="font-heading text-lg font-bold text-navy">from £{p.price_from}</span>
                  <Button size="sm" className="bg-brand hover:bg-brand/90" onClick={() => toast.success(`Trip enquiry started for ${p.title}. Our team will contact you to plan the itinerary.`)} data-testid={`plan-${p.key}`}>Plan My Trip</Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
